import { makeStyles } from "@material-ui/core/styles";
// import theme from "theme";
const drawerWidth = 200;
export const toolbarHeight = 73;
export const filterToolbarHeight = 68;

const useStyles = makeStyles((theme) => ({
  "@global": {
    html: {
      height: "100%",
    },
    body: {
      backgroundColor: "#E5E9EE",
      margin: "0",
      height: "100%",
      fontFamily: "Arial, sans-serif",
    },
  },
  root: {
    display: "flex",
  },
  alignHeaderCenter: {
    display: 'flex', 
    alignItems: 'center', 
  },
  entityHeaderContainer: {
    paddingRight: '16px',
  },
  headerTitleEntity: {
    fontSize: '20px', 
    color: 'white', 
    marginLeft: '16px', 
    width: '100%',
    overflow: 'hidden',
  },
  entityHeaderText: {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  pageContent: {
    flexGrow: 1,
  },
  busyIndicator: {
    height: "1px",
  },
  paper: {
    padding: theme.spacing(16),
  },
  appBar: {
    // width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  navBarList: {
    color: "#383737",
    padding: 27,
    display: "flex",
    alignItems: "center",

  },
  listSelected: {
    backgroundColor: "#7FA1C7",
  },
  title: {
    flexGrow: 1,
    textAlign: "center",
  },
  toolbarButtons: {
    marginLeft: "auto",
  },
  toolbar: {
    minHeight: toolbarHeight,
    padding: 0,
  },
  fakeToolbar: {
    minHeight: toolbarHeight,
    padding: 0,
    [theme.breakpoints.down("md")]: {
      minHeight: 141
    }
  },
  toolbarResponsive: {
    minHeight: 130,
    padding: 0,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    position: "relative",
    zIndex: 1,
  },
  drawerContent: {
    background: "#F5F5F5",
    // height: `calc(100% - ${toolbarHeight}px)`,
    height: "100%",
    paddingTop: toolbarHeight,
    boxShadow: "0px 3px 6px #00000060",
    position: "fixed",
  },
  drawerText: {
    fontWeight: "bold",
  },
  rightDrawer: {
    background: "#FFF",
    width: '280px'
  },
  sidebarLogo: {
    background: "#0B2541",
    opacity: 1,
    color: "#FFFFFF",
    padding: theme.spacing(1),
  },
  sidebarList: {
    color: "#FFFFFF",
  },
  sidebarListM: {
    width: drawerWidth,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  AvatarSmall: {
    backgroundColor: "#57769A",
    cursor: "pointer",
    marginRight: 40,
  },
  applogo: {
    opacity: 1,
    //borderRadius: "112px",
    paddingRight: "1vh",
    marginRight: 24,
  },
  asuLogo: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
  },
  asuLogoBox: {
    marginLeft: "auto",
    display: "flex",
  },
  headerBackgroundBox: {
    display: "flex",
    justifyContent: "space-between",
    background: "#030C33",
    width: "100%",
  },
  headerBackgroundBoxResponsive: {
    // display: 'flex',
    flex: 1,
    justifyContent: "space-between",
    backgroundColor: "#2352D0",
    alignItems: "center",
  },
  header: {
    minHeight: toolbarHeight,
    justifyContent: "left",
    backgroundColor: "#2352D0",
    width: '100vw'
  },
  subNav: {
    width: 200,
    position: "absolute",
    zIndex: 1800,
    background: "#F2F2F2",
    marginTop: 63,
    display: "none",
    "& ul": {
      listStyleType: "none",
      padding: 0,
      margin: 0,
      "& li": {
        paddingTop: 16,
        paddingBottom: 16,
        color: "#000000",
        "&:hover": {
          backgroundColor: "#E5E5E5",
        },
      },
    },
  },
  subLink: {
    textDecoration: "none",
  },
  headerBox: {
    width: "100%",
  },
  navLink: {
    textDecoration: "none",
    "&.active": {
      borderBottom: "10px solid #5C77BF",
      paddingTop: 10,
      backgroundColor: "#718CD4",
      "&:hover": {
        paddingTop: 0,
        borderBottom: "0",
      },
    },
  },
  headerTitleItem: {
    background: "#2352D0",
    // width: "30vh",
    display: "flex",
    minHeight: "inherit",
    textAlign: "center",
    width: 260,
  },
  headerItemSelected: {
    borderBottom: "10px solid #5C77BF",
    paddingTop: 10,
    backgroundColor: "#718CD4",
  },
  headerText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "25px",
    textAlign: "left"
  },
  headerItems: {
    minHeight: "inherit",
    textAlign: "center",
    display: "flex",
    minWidth: 200,
    height: "100%",
    "&:hover": {
      borderBottom: "10px solid #5C77BF",
      paddingTop: 10,
      background: "#718CD4",
      "& $subNav": {
        display: "block",
      },
      "& $arrowDownIcon": {
        transform: "rotate(180deg)",
      },
    },
  },
  headerItemResponsive: {
    minHeight: "inherit",
    textAlign: "center",
    flex: 1,
    minWidth: 200,
    height: "100%",
    direction: "row",
  },
  headerLogo: {
    minHeight: "inherit",
    textAlign: "center",
    display: "flex",
    // minWidth: 200, This causes problems on different browsers
  },
  headerItemText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "18px",
    textDecoration: "none",
    backgroundColor: "inherit",
    verticalAlign: "middle",
    display: "inline-flex",
  },
  arrowDownIcon: {
    marginLeft: 4,
    transform: "rotate(0deg)",
    transition: "transform 250ms ease-in-out",
  },
  arrowDownIconReverse: {
    transform: "rotate(180deg)",
    transition: "transform 250ms ease-in-out",
    marginLeft: 4,
  },
  headerItemButton: {
    minWidth: "100%",
    minHeight: "100%",
    borderRadius: "0px",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  headerItemButtonSelected: {
    minWidth: "100%",
    minHeight: "100%",
    borderRadius: 0,
  },
  headerGrid: {
    minHeight: "8.5vh",
  },
  headerTextBox: {
    minWidth: 69,
    backgroundColor: "#1E1E1E",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      justifyContent: "start",
    }
  },
  headerTextBoxResponsive: {
    backgroundColor: "#2352D0",
    cursor: "pointer",
  },
  headerToolBar: {
    minHeight: "8.5vh",
  },
  itemTextBox: {
    width: "100%",
    height: "8vh",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  settingsVisualContainer: {
    height: 68,
    backgroundColor: "#323232",
    display: 'none',
    [theme.breakpoints.down("md")]: {
      display: 'flex'
    }
  },
  visualContainer: {
    height: 68,
    backgroundColor: "#323232",
    paddingLeft: 25,
    paddingRight: 25,
    display: 'none',
    [theme.breakpoints.down("md")]: {
      display: 'flex'
    }
  },
  visualItem: {
    height: 68,
    padding: 10,
    // justifyContent: 'center',
    alignItems: "center",
    // width: '100%',
    backgroundColor: "white",
  },
  menuIcon: {
    color: "white",
  },
  drawerHeaderText: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "black",
    padding: 20
  },
  homeIcon: {
    height: 40, 
    width: 40, 
    color: '#E5E9EE'
  },
  headerTitle: {
    display: 'flex', 
    alignItems: 'center', 
    fontSize: '20px', 
    color: 'white', 
    marginLeft: '16px', 
    width: '100%'
  },
}), { index: 999 });

export default useStyles;
